import { useState } from 'react';

const useHookFormStepNavigation = navigate => {
  const [currentStep, setCurrentStep] = useState(1);
  const [reachedStep, setReachedStep] = useState(0);

  const handlePrevStep = () => {
    navigate(`step${currentStep - 1}`);
    setCurrentStep(prevStep => prevStep - 1);
  };

  const handleNextStep = () => {
    setCurrentStep(prevStep => prevStep + 1);
    if (reachedStep < currentStep) {
      setReachedStep(curStep => curStep + 1);
    }
  };

  return {
    currentStep,
    reachedStep,
    setCurrentStep,
    setReachedStep,
    handlePrevStep,
    handleNextStep,
  };
};

export default useHookFormStepNavigation;
